import { zodResolver } from "@hookform/resolvers/zod";
import { format } from "date-fns";
import { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { MultiValue } from "react-select";
import { z } from "zod";
import { DateRange } from "react-day-picker";
import { WithdrawContext } from "../../../../../../app/contexts/WithdrawContext";
import { OptionType } from "../../../../../../app/utils/optionSelectType";
import { useParams } from "react-router-dom";
import { ComissionType } from "../../../../../../app/utils/comissionType";

const schema = z.object({
  startDate: z.string().optional(),
  endDate: z.string().optional(),
  type: z.array(z.string()).optional(),
  status: z.array(z.string()).optional(),
});

type FormFilterData = z.infer<typeof schema>;

const optionCommissionType = [
  { value: ComissionType.A, label: "Automática" },
  { value: ComissionType.M, label: "Manual" },
];
export const useSellerCommissionFilterController = () => {
  const { id } = useParams();
  const [selectedStatusOptions, setSelectedStatusOptions] = useState<
    MultiValue<OptionType>
  >([]);
  const [selectedCommissionTypeOptions, setSelectedCommissionTypeOptions] =
    useState<MultiValue<OptionType>>([]);
  const [selectedDate, setSelectedDate] = useState<DateRange | undefined>(
    undefined,
  );

  const { setFilterParams } = useContext(WithdrawContext);

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm<FormFilterData>({
    resolver: zodResolver(schema),
  });

  const handleSelectStatus = (
    selectedStatusOptions: MultiValue<OptionType>,
  ) => {
    setValue(
      "status",
      selectedStatusOptions?.map((option) => option.value.toString()) || [],
    );
    setSelectedStatusOptions(selectedStatusOptions);
  };

  const handleSelectCommissionType = (
    selectedCommissionTypeOptions: MultiValue<OptionType>,
  ) => {
    setValue(
      "type",
      selectedCommissionTypeOptions?.map((option) => option.value.toString()) ||
        [],
    );
    setSelectedCommissionTypeOptions(selectedCommissionTypeOptions);
  };

  const handleClearFilter = () => {
    reset({
      startDate: "",
      endDate: "",
    });
    setSelectedStatusOptions([]);
    setSelectedCommissionTypeOptions([]);
    setSelectedDate(undefined);
  };

  const handleDateChange = (dateRange: DateRange | undefined) => {
    setSelectedDate(dateRange);
    if (dateRange?.from) {
      setValue("startDate", format(dateRange.from, "yyyy-MM-dd"));
    } else {
      setValue("startDate", "");
    }
    if (dateRange?.to) {
      setValue("endDate", format(dateRange.to, "yyyy-MM-dd"));
    } else {
      setValue("endDate", "");
    }
  };

  const handleFilterSubmit = handleSubmit(async (data) => {
    try {
      let endDatePlusOneDay;

      if (data.endDate) {
        endDatePlusOneDay = new Date(data.endDate);

        endDatePlusOneDay.setDate(endDatePlusOneDay.getDate() + 1);
      }

      const startDate = data.startDate
        ? format(new Date(data.startDate), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
        : undefined;
      const endDate = endDatePlusOneDay
        ? format(endDatePlusOneDay, "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
        : undefined;

      let status = "";
      let type = "";

      if (data.status && data.status?.length > 0) {
        status = data.status.map((status) => status).join(",");
      }

      if (data.type && data.type?.length > 0) {
        type = data.type.map((type) => type).join(",");
      }

      const params = {
        startDate,
        endDate,
        status: status || undefined,
        sellerId: id || undefined,
        type: type || undefined,
      };

      setFilterParams(params);
    } catch (error) {
      console.log(error);
    }
  });

  return {
    handleFilterSubmit,
    handleClearFilter,
    register,
    errors,
    isSubmitting,
    selectedStatusOptions,
    handleSelectStatus,
    optionCommissionType,
    selectedCommissionTypeOptions,
    handleSelectCommissionType,
    selectedDate,
    handleDateChange,
  };
};
